<div class="post-composer-modal">
  <div class="post-composer-modal__target" *ngIf="isProjectLocked() || isEventLocked() || canSwitchProjectTarget()">
    <div class="post-composer-modal__target-label">{{ 'shared.share.composer.target_label' | translate }}</div>

    <div *ngIf="isProjectLocked()" class="post-composer-modal__target-value">
      {{ projectLabel(projectVM) }}
    </div>

    <div *ngIf="isEventLocked()" class="post-composer-modal__target-value">
      {{ eventAM?.name }}
    </div>

    <p-dropdown
      *ngIf="canSwitchProjectTarget()"
      [options]="selectableProjects"
      [showClear]="true"
      [loading]="loadingProjects"
      appendTo="body"
      [placeholder]="'shared.share.composer.global_target' | translate"
      [(ngModel)]="selectedProject"
      [optionLabel]="'displayVehicleIdentity'">
      <ng-template pTemplate="selectedItem">
        <span *ngIf="selectedProject; else globalTarget">{{ projectLabel(selectedProject) }}</span>
        <ng-template #globalTarget>{{ 'shared.share.composer.global_target' | translate }}</ng-template>
      </ng-template>
      <ng-template let-item pTemplate="item">
        {{ projectLabel(item) }}
      </ng-template>
    </p-dropdown>
  </div>

  <div class="post-composer-modal__target" *ngIf="isGlobalEdit()">
    <div class="post-composer-modal__target-label">{{ 'shared.share.composer.target_label' | translate }}</div>
    <div class="post-composer-modal__target-value">{{ 'shared.share.composer.global_target' | translate }}</div>
  </div>

  <app-social-input
    #composerInput
    [label]="(sharedPost && !editingPost ? 'shared.share.composer.placeholder_share' : 'common.write_something') | translate"
    [value]="editingPost?.content || ''"
    [mediaObjectAMs]="initialMediaObjectAMs"
    [allowEmptySubmit]="!!editingPost"
    [minEditorHeight]="300"
    [maxEditorHeight]="520"
    [loading]="submitting"
    (submitted)="onComposerSubmit($event)">
  </app-social-input>

  <app-share-card *ngIf="previewCard"
                  class="post-composer-modal__share-card"
                  [card]="previewCard"
                  mode="preview">
  </app-share-card>

  <div class="post-composer-modal__actions">
    <button
      pButton
      type="button"
      [rounded]="true"
      [label]="(editingPost ? 'common.save' : sharedPost ? 'common.share' : 'common.publish') | translate"
      [loading]="submitting"
      [disabled]="!composerInput || composerInput.isSubmitActionDisabled()"
      (click)="submitComposer()">
    </button>
  </div>
</div>
